var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(2110 3333)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(-2106 -3329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3345",
    "data-name": "Group 3345",
    transform: "translate(-67 -1850)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 16,
    height: 16,
    transform: "translate(-2043 -1483)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aabf409156b2bcde53225f3492dda1ba",
    d: "M8.971,2a6.971,6.971,0,1,0,6.971,6.971A6.992,6.992,0,0,0,8.971,2Zm2.579,8.575a.69.69,0,0,1-.976.976l-1.6-1.6-1.6,1.6a.69.69,0,0,1-.976-.976L8,8.971l-1.6-1.6a.69.69,0,0,1,.976-.976L8.971,8l1.6-1.6a.69.69,0,0,1,.976.976l-1.6,1.6Z",
    transform: "translate(-2043.971 -1483.971)",
    fill: "#e50914"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.11496c24b1c419d3d0d990a799a0db3f.svg";
export { ForwardRef as ReactComponent };